import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { useFullLocation } from '../routing';
import { User } from 'oidc-client-ts';

import { BRANDS } from '../../components/Itv/types';

export const useSignIn = (): ((params?: {
  acrValues?: string;
  returnQueryParameters?: Record<string, string>;
  theme?: BRANDS;
}) => Promise<void> | Promise<User>) => {
  const auth = useAuth();
  const fullLocation = useFullLocation();

  return useCallback(
    (params?: { acrValues?: string; returnQueryParameters?: Record<string, string>; theme?: BRANDS }) => {
      const url = new URL(fullLocation);

      if (url.pathname === '/login' || url.pathname === '/registration') {
        url.pathname = '/';
      }

      const newParams = new URLSearchParams(url.search);

      if (params?.returnQueryParameters) {
        Object.entries(params?.returnQueryParameters).forEach(([key, value]) => {
          newParams.set(key, value);
        });
      }

      url.search = newParams.toString();
      const isPopup = !!params?.acrValues;
      const signupFunction = isPopup ? auth.signinPopup : auth.signinRedirect;

      return signupFunction.bind(auth)({
        redirect_uri: url.toString(),
        ...(params?.theme
          ? {
              extraQueryParams: { theme: params.theme },
            }
          : {}),
      });
    },
    [auth, fullLocation]
  );
};
